import { RouteConfigSingleView } from 'vue-router/types/router';
import { PermissionList } from '@/modules/backend/PermissionList';

export interface RouteConfigWithPermission extends RouteConfigSingleView {
  PermissionAlias?: PermissionList;
}

type ImportedComponent = typeof import('*.vue');

export const dashboard: RouteConfigWithPermission[] = [
  {
    path: '/types',
    name: 'dashboard.types',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.types" */ '@/views/Dashboard/Types.vue'),
    meta: {
      PermissionAlias: PermissionList.MODELS_VIEW,
    }
  },
  {
    path: '/events',
    name: 'dashboard.events',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.events" */ '@/views/Dashboard/Events.vue')
  },
  {
    path: '/permissions',
    name: 'dashboard.permissions',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.permissions" */ '@/views/Dashboard/Permissions.vue'),
    meta: {
      PermissionAlias: PermissionList.PERMISSION_EDIT
    }
  },
  {
    path: '/users',
    name: 'dashboard.users',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.users" */ '@/views/Dashboard/Users.vue')
  },
  {
    path: '/companies',
    name: 'dashboard.companies',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.companies" */ '@/views/Dashboard/Companies.vue'),
    meta: {
      PermissionAlias: PermissionList.COMPANIES_VIEW
    }
  },
  {
    path: '/company/:companyId',
    name: 'dashboard.company.buildings',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.company.buildings" */ '@/views/Dashboard/CompanyBuildingsView.vue'),
    meta: {
      PermissionAlias: PermissionList.BUILDINGS_VIEW
    }
  },
  {
    path: '/building/:buildingId',
    name: 'dashboard.building',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.building" */ '@/views/Dashboard/LocationsView.vue'),
    children: [
      {
        path: '/building/:buildingId/locations',
        name: 'dashboard.building.locations',
        component: (): Promise<ImportedComponent> =>
          import(/* webpackChunkName: "dashboard.building.locations" */ '@/views/Dashboard/Locations.vue'),
        meta: {
          PermissionAlias: PermissionList.LOCATIONS_VIEW
        }
      },
      {
        path: '/building/:buildingId/rates',
        name: 'dashboard.building.rates',
        component: (): Promise<ImportedComponent> =>
          import(/* webpackChunkName: "dashboard.building.rates" */ '@/views/Dashboard/RatesView.vue'),
        meta: {
          PermissionAlias: PermissionList.RATES_VIEW
        }
      }
    ]
  },
  {
    path: '/location/:locationId',
    name: 'dashboard.location.accounts',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.location.accounts" */ '@/views/Dashboard/LocationAccountsView.vue'),
    meta: {
      PermissionAlias: PermissionList.COUNTERS_VIEW,
    }
  },
  {
    path: '/accounts/:accountId',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.account.counters" */ '@/views/Dashboard/Account/AccountSingleView.vue'),
    meta: {
      PermissionAlias: PermissionList.ACCOUNTS_VIEW
    },
    children: [
      {
        path: '',
        name: 'dashboard.account.counters',
        component: (): Promise<ImportedComponent> =>
          import(/* webpackChunkName: "dashboard.account.rates" */ '@/views/Dashboard/Account/AccountCountersView.vue'),
        meta: {
          PermissionAlias: PermissionList.ACCOUNTS_VIEW
        }
      }
    ]
  },
  {
    path: '/my-counters',
    name: 'dashboard.account.mycounters',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.account.mycounters" */ '@/views/Dashboard/Account/AccountSingleView.vue'),
    meta: {
      PermissionAlias: PermissionList.ACCOUNTS_VIEW
    }
  },
  {
    path: '/counters/:counterId',
    name: 'dashboard.account.counter',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.account.counter" */ '@/views/Dashboard/Account/Counters.vue'),
    meta: {
      PermissionAlias: PermissionList.COUNTERS_DATA_VIEW
    }
  },
  {
    path: '/providers',
    name: 'dashboard.providers',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.providers" */ '@/views/Dashboard/Providers.vue')
  },
  {
    path: '/buildings',
    name: 'dashboard.buildings',
    component: (): Promise<ImportedComponent> =>
      import(/* webpackChunkName: "dashboard.buildings" */ '@/views/Dashboard/Buildings/BuildingsView.vue')
  }
];
